module.exports = __webpack_public_path__ + "static/media/advanceFee.a9f97eec.svg";